import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import VueGtag from "vue-gtag";
import './assets/icons/icons.js'
import './components/components.js'

Vue.config.productionTip = false

import { BootstrapVue, IconsPlugin  } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./styles/index.scss";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import wb from "./registerServiceWorker";
import i18n from "@/js/i18n.js";
import PrimeVue from "primevue/config";
import VueNumberFormat from '@coders-tm/vue-number-format';
import Antd from 'ant-design-vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import "vue2-datepicker/locale/th";
import "vue2-datepicker/locale/en";
import "vue2-datepicker/locale/vi";
import "ant-design-vue/dist/antd.css";

Vue.use(VueNumberFormat);

Vue.config.productionTip = false;

Vue.prototype.$workbox = wb;

Vue.use(BootstrapVue)
Vue.use(Toast)
Vue.use(IconsPlugin)
Vue.use(PrimeVue)
Vue.use(Antd)
DatePicker.locale(store.state.selectLang.lang);
Vue.component('DatePicker', DatePicker);
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG_ID }
})

Vue.filter("formatNumberFull", function ([value, decimal]) {
  function roundToDecimalPlaces(number, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(number * factor) / factor; // ปัดเศษตามปกติ
  }

  if (!value) return value; // ตรวจสอบค่า null หรือ undefined

  const num = Number(value);
  if (isNaN(num)) return value;

  if (decimal) {
    // ปัดทศนิยมตามจำนวนที่ระบุ
    const formattedNumber = roundToDecimalPlaces(num, decimal);
    return formattedNumber.toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal
    });
  } else {
    // ตรวจสอบจำนวนทศนิยมจากค่าจริง
    const decimalPlaces = value.toString().split(".")[1]?.length || 0;
    const formattedNumber = roundToDecimalPlaces(num, decimalPlaces);
    return formattedNumber.toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces
    });
  }
});
new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");